import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import DescriptionField from "components/support/description-field";

export default class CompanyGeographicInfo extends Component {
  render() {
    const { company } = this.props;
    const address = company.address || {};
    const fiscal_informations = company.fiscal_informations || {};

    return (
      <div className="grid-container">
        <Row>
          <Col xs={12} sm={4}>
            <DescriptionField
              label="CEP"
              value={address.zipcode}
              mask={[/\d/, /\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/]}
            />
          </Col>
          <Col xs={12} sm={4}>
            <DescriptionField label="Estado" value={address.state} />
          </Col>
          <Col xs={12} sm={4}>
            <DescriptionField label="Cidade" value={address.city} />
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={6}>
            <DescriptionField
              label="Código do Município"
              value={fiscal_informations.municipal_code}
            />
          </Col>
          <Col xs={12} sm={6}>
            <DescriptionField label="Bairro" value={address.neighborhood} />
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={4}>
            <DescriptionField label="Logradouro" value={address.street} />
          </Col>
          <Col xs={12} sm={2}>
            <DescriptionField label="Número" value={address.number} />
          </Col>
          <Col xs={12} sm={6}>
            <DescriptionField label="Complemento" value={address.complement} />
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/registration/company/view/geographic-info/index.jsx